import { removeDeleted } from '@src/lib/func';
import { getBusinesses } from '@store/entities/businesses/selectors';
import { BusinessWithUsers } from '@store/entities/businesses/types';
import { useAppSelector } from '@store/hooks';

export const useActiveBusinesses = () => {
  const businesses = useAppSelector(getBusinesses()) || [];
  return removeDeleted(businesses) as BusinessWithUsers[];
};
